import React from 'react';
import { useSelector } from 'react-redux';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getCountryCode, getMobileNumber } from '../../../../../../Assests/Utility';

const CSCESelfServe = (props) => {

    const user = useSelector(getUserSelector);
    const { userAccountDetails } = user;

    const { CUID, Email, FirstName, LastName, Phone } = userAccountDetails || {};
    const phone = getMobileNumber(Phone);
    const countryCode = getCountryCode(Phone);

    const selfServeURL = `${process.env.REACT_APP_CSCE_USER_BASEURL}?type=user&cuid=${CUID}&email=${Email}&firstName=${FirstName}&lastName=${LastName}&phone=${phone}&countryCode=${countryCode}&apptype=ims&supporttype=selfserve`;

    return (
        <div style={{ flex: '1' }}>
            <iframe
                src={selfServeURL}
                frameBorder="0"
                style={{ width: '100%', height: '100%' }}
                title="Self Serve Support"
            />
        </div>
    );
};

export default CSCESelfServe;
